import { Link } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { useTranslation } from "react-i18next"

const Profile = ({style = 'style-one'}) => {

    const {user, logout} = useAuth()
    const {t} = useTranslation()

    return (
        <>
            {
                style == 'style-one' && (
                    <li className={`border-right-item on-hover-item ${user && 'has-submenu arrow-white'}`}>
                        {
                            user ? (
                            <>
                                <span className="py-8 text-sm text-white selected-text">{user.name}</span>
                                <ul className='px-0 py-8 selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm dropdown-to-left'>
                                    <li className="px-2">
                                        <Link 
                                            to="/profile"
                                            className="tw-text-gray-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-block tw-px-4 tw-py-2"
                                        >
                                            {t('profile.settings')}
                                        </Link>
                                    </li>
                                    <li className="px-2">
                                        <Link 
                                            to="/orders"
                                            className="tw-text-gray-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-block tw-px-4 tw-py-2"
                                        >
                                            {t('orders.your_orders') || 'Your Orders'}
                                        </Link>
                                    </li>
                                    <li className="px-2">
                                        <button 
                                        onClick={() => logout()}
                                        type="button" 
                                        className="tw-text-red-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-px-4 tw-py-2">{t('common.logout')}</button>
                                    </li>
                                </ul>
                            </>
                            ) : (
                            <Link
                                to='/login'
                                className='gap-6 py-8 text-sm text-white flex-align'
                            >
                                <span className='hover-text-decoration-underline'>
                                {t('common.login')}
                                </span>
                            </Link>
                            )
                        }
                    </li>
                )
            }
            {
                style == 'style-two' && (
                    <div className={`gap-8 item-hover-two flex-column flex-align on-hover-item tw-cursor-pointer ${user && 'has-submenu arrow-white'} ` }>
                        <span className='text-2xl text-white d-flex position-relative item-hover__text selected-text'>
                            <i className='ph ph-user' />
                        </span>
                        {
                            user ? (
                                <div className={`on-hover-item`}>
                                    <span className="text-white text-md item-hover__text d-none d-lg-flex">{user.name}</span>
                                    <ul className='px-0 py-8 tw-text-left selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm dropdown-to-left'>
                                        <li className="px-2">
                                            <Link 
                                                to="/profile"
                                                className="tw-text-gray-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-block tw-px-4 tw-py-2"
                                            >
                                                {t('profile.settings')}
                                            </Link>
                                        </li>
                                        <li className="px-2">
                                            <Link 
                                                to="/orders"
                                                className="tw-text-gray-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-block tw-px-4 tw-py-2"
                                            >
                                                {t('orders.your_orders') || 'Your Orders'}
                                            </Link>
                                        </li>
                                        <li className="px-2 tw-whitespace-nowrap">
                                            <button 
                                            onClick={() => logout()}
                                            type="button" 
                                            className="tw-text-red-800 hover:tw-bg-gray-100 tw-rounded tw-w-full tw-px-4 tw-py-2">{t('common.logout')}</button>
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                <Link
                                    to='/login'
                                    className='gap-8 flex-align flex-column item-hover-two'
                                >
                                    <span className='text-white text-md item-hover__text d-none d-lg-flex'>
                                        {t('common.login')}
                                    </span>
                                </Link>
                            )
                        }
                    </div>
                )
            }
        </>
        
    )
}

export default Profile